export default __webpack_public_path__ + "static/media/profp compressed.17025ade.jpg";